<template>
  <div>
    <a-result status="404" title="Strona nie istnieje lub nie masz dostępu do sieci">
      <template #subTitle>
        <div>
          Sprawdź szczegóły na stronie głównej. Tam możesz złożyć wniosek o dostęp <br>lub zalogować się by dodać kolejne urządzenie do swojego konta użytkownika.
        </div>
      </template>
    </a-result>
    <div style="text-align: center">
      <a-button slot="action" type="primary" @click="$router.push({name: 'Home'})">Dowiedz się więcej, przejdź na stronę główną...</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error404",
  data() {
    return {};
  },
  mounted() {
    this.$emit("loadedView");
  },
};
</script>
